import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  clearUploadedVideo,
  createMediaSubmission,
  getCampaignElementById,
  getHasUploadedVideoForQuestionId,
  getHasVideoBucketUploadFailed,
  getPreSignedUrlForUpload,
  getIpAddress,
  selectVideo,
  setMediaType,
  uploadVideoToBucket,
  getIsVideoUploadingToBucket,
  getCampaignId
} from '../../redux/modules/campaignLandingPage';
import styles from './VideoUploadButton.module.less';
import { ACCEPT_TYPES } from '../../constants';

function handleFileSelect(
  files,
  qid,
  _createMediaSubmission,
  _selectVideo,
  _setMediaType,
  _clearUploadedVideo,
  mediaSubmission
) {
  _clearUploadedVideo(qid);
  const [file] = files;
  mediaSubmission.mimeType = file.type;

  // Save file type so we can use it in the video preview
  _setMediaType(qid, file.type);

  // Create an object URL and persist it to store
  const objectUrl = window.URL.createObjectURL(file);
  _selectVideo(qid, objectUrl);
  // Fetch a pre-signed URL and store it
  _createMediaSubmission(mediaSubmission, qid);
}

const VideoUploadButton = ({
  _clearUploadedVideo,
  _createMediaSubmission,
  _selectVideo,
  _setMediaType,
  _uploadVideoToBucket,
  hasUploadedVideo,
  qid,
  signedUrl,
  userIpAddress,
  isVideoUploading,
  isDirectRecording = false,
  campaignId
}) => {
  const fileInput = useRef(null);
  const buttonLabel = isDirectRecording ? 'Record a Video' : 'Upload a Video';
  const mediaSubmission = {
    isRecorded: false,
    userAgent: navigator.userAgent,
    userIp: userIpAddress,
    screenResolution: `${window.outerWidth}x${window.outerHeight}`,
    campaignId
  };

  useEffect(() => {
    if (signedUrl !== null && hasUploadedVideo === false && fileInput.current.files.length) {
      const file = fileInput.current.files[0];
      _uploadVideoToBucket(file, signedUrl, qid);
    }
  }, [signedUrl]);

  const fileInputProps = {
    type: 'file',
    capture: isDirectRecording ? 'user' : null,
    disabled: isVideoUploading,
    id: `vpUploadInput-${qid}-${isDirectRecording}`,
    accept: ACCEPT_TYPES.VIDEO,
    ref: fileInput,
    className: styles.vpVisuallyHidden,
    onChange: (e) =>
      handleFileSelect(
        e.target.files,
        qid,
        _createMediaSubmission,
        _selectVideo,
        _setMediaType,
        _clearUploadedVideo,
        mediaSubmission
      )
  };
  return (
    <>
      <label
        htmlFor={`vpUploadInput-${qid}-${isDirectRecording}`}
        className={`${styles.vpUploadVideoButton}
        ${isVideoUploading ? styles.vpInputDisabled : ''}
        ${isDirectRecording ? styles.vpRecordButtonStyle : ''}`}
      >
        <Icon icon={isDirectRecording ? 'circle' : 'upload'} />
        {buttonLabel}
      </label>
      <input {...fileInputProps} />
    </>
  );
};

VideoUploadButton.propTypes = {
  _clearUploadedVideo: PropTypes.func,
  _createMediaSubmission: PropTypes.func,
  _selectVideo: PropTypes.func,
  _setMediaType: PropTypes.func,
  _uploadVideoToBucket: PropTypes.func,
  campaignElement: PropTypes.object,
  hasUploadedVideo: PropTypes.bool,
  hasUploadFailure: PropTypes.bool,
  qid: PropTypes.string,
  signedUrl: PropTypes.string,
  userIpAddress: PropTypes.string,
  isVideoUploading: PropTypes.bool,
  isDirectRecording: PropTypes.bool,
  campaignId: PropTypes.number
};

function mapStateToProps(state, ownProps) {
  return {
    campaignElement: getCampaignElementById(state, ownProps.qid),
    hasUploadedVideo: getHasUploadedVideoForQuestionId(state, ownProps.qid),
    hasUploadFailure: getHasVideoBucketUploadFailed(state, ownProps.qid),
    signedUrl: getPreSignedUrlForUpload(state, ownProps.qid),
    userIpAddress: getIpAddress(state),
    isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
    campaignId: getCampaignId(state)
  };
}

const mapDispatchToProps = {
  _clearUploadedVideo: clearUploadedVideo,
  _createMediaSubmission: createMediaSubmission,
  _selectVideo: selectVideo,
  _setMediaType: setMediaType,
  _uploadVideoToBucket: uploadVideoToBucket
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoUploadButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoUploadButton.jsx